import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Label } from '../../components/widgets';
import Card from '../../organizationPlan/components/Card';
import css from './StepCard.css';

const StepCard = ({
    title = '',
    titleTextReplace = {},
    description = '',
    descriptionTextReplace = {},
    className = '',
    contentClassName = '',
    headerChildren = null,
    children,
    ...props
}) => {
    const header = (
        <div className={css.header}>
            <div className={css.titleWrapper}>
                {title && <Label text={title} textReplace={titleTextReplace} type="subtitle" className={css.title} />}
                {description && <Label text={description} textReplace={descriptionTextReplace} type="p" />}
            </div>
            {headerChildren}
        </div>
    );

    return (
        <Card
            {...props}
            cardClassName={classNames(css.card, className)}
            contentClassName={classNames(css.content, contentClassName)}
            header={header}
        >
            {children}
        </Card>
    );
};

StepCard.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    headerChildren: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    title: PropTypes.string,
    titleTextReplace: PropTypes.object,
    descriptionTextReplace: PropTypes.object,
    description: PropTypes.string,
    className: PropTypes.string,
    contentClassName: PropTypes.string,
};

export default StepCard;
